import {
  buildUrlFromBase,
  eolsBaseApi,
  withApiErrorLoggingOnly
} from '../../utilities/api.utilities';
import {
  OsmosisTokenDto,
  VitalSourceDto,
  VitalSourceFetchConfig,
} from './sherpath-course-management-service.dtos';
import { addSearchParams } from '../../utilities/app.utilities';

export const fetchOsmosisToken = (): Promise<OsmosisTokenDto> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.get(buildUrlFromBase('/api/sherpath/course-management/osmosis/token'));
  });
};

export const fetchVitalSource = (config: VitalSourceFetchConfig): Promise<VitalSourceDto> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.post<VitalSourceDto>(buildUrlFromBase(addSearchParams(`/api/sherpath/course-management/vst/isbn/${config.isbn}/page/${config.page}`, {
        vitalSourceId: 'sher_evol'
      })));
  });
};
